import { Input, Table } from 'antd'
import styled from 'styled-components'

export const StyledTable = styled(Table)`
  && {
    width: 450px;
  }
  .ant-table-tbody > tr:hover > td {
    background-color: inherit;
  }
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    content: none;
  }
  .ant-table-thead > tr > th {
    background-color: #efefef;
    color: #5e667b;
  }
  .ant-table-tbody > tr > td {
    border: 1px solid #ccc;
    padding: 5px;
  }
`
export const RenderDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`
export const StyledSpan = styled.span`
  color: black;
  margin-top: 5px;
  margin-left: 12px;
`

export const DataLabel = styled.span`
  font-family: 'Plus Jakarta Sans';
  font-size: 12px;
  font-weight: ${props => (props.weight ? props.weight : '500')};
  color: ${props => (props.color ? 'black' : '#808697')};
  text-transform: uppercase;
  padding-left: 20px;
  display: inline-block;
`

export const TextArea = styled(Input)`
  border: 0.7px solid #d9d9d9;
  padding: 0px 4px 0px 4px;
  gap: 3px;
  width: 60%;
  height: 35px;
  margin-left: 1px;
  color: ${props => (props.color ? 'white' : 'black')};
  background-color: ${props => (props.backgroundColor ? '#5551ff' : '#efefef')};
  font-weight: ${props => (props.color ? '600' : '500')};

  &::placeholder {
    font-weight: 500;
    font-size: 12px;
    font-family: 'Plus Jakarta Sans';
    line-height: 20px;
    padding-left: 10px;
  }

  .ant-input-prefix {
    margin-right: 4px;
    font-size: larger;
    font-weight: 500;
  }
`
export const CenteredContainer = styled.div`
  display: grid;
  margin-top: 10%;
`
